import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'item',
    'message',
    'pageBreak',
    'template',
  ]

  static values = {
    labelsPerPage: Number,
    message: String,
  }

  connect() {
    this.update()
  }

  itemTargetConnected() {
    this.update()
  }

  itemTargetDisconnected() {
    this.update()
  }

  update() {
    this.pageBreakTargets.forEach((pageBreak) => pageBreak.remove())
    const visibleItems = this.itemTargets.filter((item) => item.checkVisibility())
    for(
      let index = this.labelsPerPageValue - 1;
      index < visibleItems.length;
      index = index + this.labelsPerPageValue
    ) {
      this.#insertPageBreakAfter(visibleItems[index])
    }

    const remaining = this.labelsPerPageValue - (visibleItems.length % this.labelsPerPageValue)
    const message = this.messageValue.replace('COUNT', remaining)
    this.messageTarget.innerHTML = message
  }

  #insertPageBreakAfter(item) {
    const clone = this.templateTarget.content.cloneNode(true)
    item.after(clone)
  }
}
